export default function convertToBoolean(value) {
  const valueType = typeof value;

  if (valueType === 'boolean') {
    return value;
  }

  if (valueType === 'string') {
    return value.toLowerCase() === 'true';
  }

  return false;
}
